import { Printer, PrintOptions } from '@awesome-cordova-plugins/printer';

export class PrintService {
  constructor(private $q: ng.IQService, private $log: ng.ILogService) {
    'ngInject';
  }

  private getPrintPdfPlugin(): PrintPdfPlugin {
    return (window as any).plugins.PrintPDF;
  }

  isAvailable(): ng.IPromise<boolean> {
    return this.$q.resolve(Printer.isAvailable());
  }

  printHtmlContent(
    htmlContent: string,
    options?: PrintOptions
  ): ng.IPromise<unknown> {
    return this.isAvailable()
      .then(() => {
        return this.$q.resolve(Printer.print(htmlContent, options));
      })
      .catch(() => {
        this.$log.error('Printing is not available');
      });
  }

  printPdfUri(fileUri: string): ng.IPromise<unknown> {
    return this.printPdf(fileUri, 'File');
  }

  printPdfBase64(pdfBase64: string): ng.IPromise<unknown> {
    return this.printPdf(pdfBase64, 'Data');
  }

  private printPdf(data: string, type: 'Data' | 'File'): ng.IPromise<unknown> {
    const defer = this.$q.defer();
    const printdPdfPlugin = this.getPrintPdfPlugin();
    if (!printdPdfPlugin) {
      this.$log.error('cordova-plugin-print-pdf is not available');
      defer.reject();
    }
    printdPdfPlugin.isPrintingAvailable((isAvailable) => {
      if (isAvailable) {
        printdPdfPlugin.print({
          data,
          type,
          success: () => defer.resolve(),
          error: (err) => {
            this.$log.error('print-pdf plugin error: ', err);
            defer.reject(err);
          },
        });
      } else {
        this.$log.error('Printing is not available');
        defer.reject(false);
      }
    });
    return defer.promise;
  }
}

interface PrintPdfPlugin {
  print(options: {
    data: string;
    type: 'Data' | 'File';
    title?: 'Print Document';
    success?: () => void;
    error?: (err: unknown) => void;
  });
  isPrintingAvailable(callback: (isAvailable: boolean) => void);
}
